module.exports = __webpack_public_path__ + "static/media/exceed15project2.f5a88e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/exceed15project2.png
// module id = 852
// module chunks = 0